import {createAsyncThunk} from '@reduxjs/toolkit'

import {getSettlementDetail} from '@web/actions/saleSettlement'
import {isErrorPayload} from '@web/helpers/api'

import {ThunkApi} from '../interfaces'

const actionType = 'saleSettlementDetail'

/** 판매상세 초기화 action */
export const initSaleSettlementDetail = createAsyncThunk<
    object,
    string,
    ThunkApi<{
        code: string
        message: string
    }>
>(`${actionType}/init`, async (settleObjectNo, {dispatch, rejectWithValue}) => {
    if (!settleObjectNo) {
        return rejectWithValue({
            code: 'INVALID_SETTLE_OBJECT_NO',
            message: 'INVALID_SETTLE_OBJECT_NO',
        })
    }

    try {
        await dispatch(getSettlementDetail({settleObjectNo})).unwrap()
    } catch (e) {
        if (isErrorPayload(e)) {
            return rejectWithValue({
                code: e.code,
                message: e.fallbackMessage,
            })
        }
        throw e
    }

    return {}
})
